<template>
    <form
        @change="isFormDirty"
        @submit.prevent="handleSubmit"
        :class="{ 'form-container': typeForm, 'form-modal-container': typeModal }"
        data-cy="form-container"
    >
        <p class="text-center text-default-red p-2" v-if="validation.message">
            {{ validation.message }}
        </p>
        <div class="form-section" data-cy="section-general">
            <div class="section-body">
                <div data-cy="field-migration-type" class="input-container px-4 mb-4">
                    <ui-label>{{ $t('admin.migration.form.labels.migration_type') }}</ui-label>
                    <ui-select
                        :class="{ 'form-error': v$.migration.migration_type.$error }"
                        v-model="v$.migration.migration_type.$model"
                        :options="migration_type_options"
                        :disabled="migration.id !== 0"
                        placeholder="Please select type of Migration"
                    />
                    <div
                        data-cy="field-migration-type-error"
                        :class="{ 'text-default-red': v$.migration.migration_type.$error }"
                        v-if="v$.migration.migration_type.required.$invalid && v$.migration.migration_type.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <validation-errors :errors="validation.errors.migration_type" v-if="validation.errors" />
                </div>
                <div data-cy="field-migration-name" class="input-container px-4 mb-4">
                    <ui-label>{{ $t('admin.migration.form.labels.migration_name') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.migration.migration_name.$error }"
                        v-model="v$.migration.migration_name.$model"
                        :disabled="migration.id !== 0"
                    />
                    <div
                        data-cy="field-migration-name-error"
                        :class="{ 'text-default-red': v$.migration.migration_name.$error }"
                        v-if="v$.migration.migration_name.required.$invalid && v$.migration.migration_name.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <validation-errors :errors="validation.errors.migration_name" v-if="validation.errors" />
                </div>
                <div data-cy="field-claimsbank-ip" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.migration.form.labels.claimsbank_ip') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.migration.claimsbank_ip.$error }"
                        v-model="v$.migration.claimsbank_ip.$model"
                        :disabled="migration.id !== 0"
                    />
                    <div
                        data-cy="field-claimsbank-ip-error"
                        :class="{ 'text-default-red': v$.migration.claimsbank_ip.$error }"
                        v-if="v$.migration.claimsbank_ip.required.$invalid && v$.migration.claimsbank_ip.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <validation-errors :errors="validation.errors.claimsbank_ip" v-if="validation.errors" />
                </div>
                <div data-cy="field-claimsbank-port" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.migration.form.labels.claimsbank_port') }}</ui-label>
                    <ui-input-number
                        :class="{ 'form-error': v$.migration.claimsbank_port.$error }"
                        v-model="v$.migration.claimsbank_port.$model"
                        :disabled="migration.id !== 0"
                    />
                    <div
                        data-cy="field-claimsbank-port-error"
                        :class="{ 'text-default-red': v$.migration.claimsbank_port.$error }"
                        v-if="v$.migration.claimsbank_port.required.$invalid && v$.migration.claimsbank_port.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <validation-errors :errors="validation.errors.claimsbank_port" v-if="validation.errors" />
                </div>
                <div data-cy="field-claimsbank-user" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.migration.form.labels.claimsbank_user') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.migration.claimsbank_user.$error }"
                        v-model="v$.migration.claimsbank_user.$model"
                        :disabled="migration.id !== 0"
                    />
                    <div
                        data-cy="field-claimsbank-user-error"
                        :class="{ 'text-default-red': v$.migration.claimsbank_user.$error }"
                        v-if="v$.migration.claimsbank_user.required.$invalid && v$.migration.claimsbank_user.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <validation-errors :errors="validation.errors.claimsbank_user" v-if="validation.errors" />
                </div>
                <div data-cy="field-claimsbank-password" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('admin.migration.form.labels.claimsbank_password') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.migration.claimsbank_password.$error }"
                        type="password"
                        v-model="v$.migration.claimsbank_password.$model"
                        :disabled="migration.id !== 0"
                    />
                    <div
                        data-cy="field-claimsbank-password-error"
                        :class="{ 'text-default-red': v$.migration.claimsbank_password.$error }"
                        v-if="
                            v$.migration.claimsbank_password.required.$invalid &&
                            v$.migration.claimsbank_password.$error
                        "
                    >
                        {{ $t('validation.required') }}
                    </div>
                    <validation-errors :errors="validation.errors.claimsbank_password" v-if="validation.errors" />
                </div>
                <div data-cy="field-status" class="input-container w-1/2 px-4 mb-4" v-if="migration.id !== 0">
                    <ui-label>{{ $t('admin.migration.form.labels.status') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.migration.status.$error }"
                        v-model="v$.migration.status.$model"
                        :disabled="migration.id !== 0"
                    />
                    <validation-errors :errors="validation.errors.status" v-if="validation.errors" />
                </div>
                <div
                    data-cy="field-status-updated-at"
                    class="input-container w-1/2 px-4 mb-4"
                    v-if="migration.id !== 0"
                >
                    <ui-label>{{ $t('admin.migration.form.labels.status_updated_at') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.migration.status_updated_at.$error }"
                        v-model="v$.migration.status_updated_at.$model"
                        :disabled="migration.id !== 0"
                    />
                    <validation-errors :errors="validation.errors.status_updated_at" v-if="validation.errors" />
                </div>
                <div
                    data-cy="field-migration-started-at"
                    class="input-container w-1/2 px-4 mb-4"
                    v-if="migration.id !== 0"
                >
                    <ui-label>{{ $t('admin.migration.form.labels.migration_started_at') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.migration.migration_started_at.$error }"
                        v-model="v$.migration.migration_started_at.$model"
                        :disabled="migration.id !== 0"
                    />
                    <validation-errors :errors="validation.errors.migration_started_at" v-if="validation.errors" />
                </div>
                <div
                    data-cy="field-migration-ended-at"
                    class="input-container w-1/2 px-4 mb-4"
                    v-if="migration.id !== 0"
                >
                    <ui-label>{{ $t('admin.migration.form.labels.migration_ended_at') }}</ui-label>
                    <ui-input
                        :class="{ 'form-error': v$.migration.migration_ended_at.$error }"
                        v-model="v$.migration.migration_ended_at.$model"
                        :disabled="migration.id !== 0"
                    />
                    <validation-errors :errors="validation.errors.migration_ended_at" v-if="validation.errors" />
                </div>
            </div>
        </div>

        <div class="form-submit" v-if="form_type == 'form'">
            <ui-submit-button data-cy="submit-button" :disabled="processing">
                <span v-if="!processing">{{ $t('admin.migration.form.buttons.save') }}</span>
                <span v-else>{{ $t('admin.migration.form.buttons.saving') }}</span>
            </ui-submit-button>
        </div>

        <div class="drawer-footer" v-if="form_type == 'drawer'">
            <slot name="actions"></slot>

            <a-button data-cy="drawer-cancel-btn" class="btn-cancel" @click="onDrawerClose">
                {{ $t('admin.migration.form.buttons.cancel') }}
            </a-button>
            <a-button
                data-cy="drawer-save-btn"
                class="ant-btn-primary"
                :disabled="processing"
                @click="handleSubmit"
                v-if="!migration.id"
            >
                <span v-if="!processing">{{ $t('admin.migration.form.buttons.save') }}</span>
                <span v-else>{{ $t('admin.migration.form.buttons.saving') }}</span>
            </a-button>
        </div>
    </form>
</template>

<script>
import UiInput from '@/components/ui/Input.vue';
import UiInputNumber from '@/components/ui/InputNumber.vue';
import UiLabel from '@/components/ui/Label.vue';
import UiSelect from '@/components/ui/Select.vue';
import UiSubmitButton from '@/components/ui/SubmitButton.vue';
import ValidationErrors from '@/components/ui/ValidationErrors.vue';

import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        UiInput,
        UiInputNumber,
        UiLabel,
        UiSelect,
        UiSubmitButton,
        ValidationErrors,
    },
    validations: {
        migration: {
            migration_type: {
                required,
            },
            migration_name: {
                required,
            },
            claimsbank_ip: {
                required,
            },
            claimsbank_port: {
                required,
            },
            claimsbank_user: {
                required,
            },
            claimsbank_password: {
                required,
            },
            status: {},
            status_updated_at: {},
            is_stream_updated: {},
            migration_started_at: {},
            migration_ended_at: {},
        },
    },
    computed: {
        typeForm() {
            return this.form_type !== 'modal';
        },
        typeModal() {
            return this.form_type == 'modal';
        },
    },
    props: {
        form_type: {
            type: String,
            default: 'drawer',
        },
        migration: Object,
        processing: {
            type: Boolean,
            default: false,
        },
        validation: Object,
    },
    methods: {
        isFormDirty() {
            this.$emit('is-form-dirty', this.v$.$anyDirty);
        },
        async handleSubmit() {
            if (!(await this.v$.$validate())) return false;

            this.$emit('formSubmit', this.migration);
        },
        onDrawerClose() {
            this.$emit('onDrawerClose');
        },
    },
    data() {
        return {
            migration_type_options: [
                {
                    value: '4d',
                    text: '4D Server',
                },
            ],
        };
    },
};
</script>
